/* eslint-disable */
import React from 'react';
import { Grid } from '@mui/material';
import SectionCard from './SectionCard';
import { StyledField, StyledSelect } from './helpers';

const VILLES = ['Casablanca', 'Rabat', 'Marrakech', 'Fès', 'Tanger', 'Agadir', 'Oujda', 'Meknès'];

const LegalSection = ({ data, onChange }) => (
  <SectionCard
    id="informations-legales"
    title="Informations légales"
    subtitle="Renseignez les informations légales requises"
  >
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <StyledField
          label="ICE"
          name="ice"
          value={data.ice}
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={4}>
        <StyledField
          label="Registre de commerce"
          name="registreCommerce"
          value={data.registreCommerce}
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={4}>
        <StyledField
          label="Patente"
          name="patente"
          value={data.patente}
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={4}>
        <StyledSelect
          label="Ville"
          name="ville"
          value={data.ville}
          onChange={onChange}
          options={VILLES}
        />
      </Grid>
    </Grid>
  </SectionCard>
);

export default LegalSection;